<template>
  <v-row no-gutters>
    <sidebar-checkbox-filter v-for="(attribute, idx) of attributes" :key="idx" v-bind="attribute" />
  </v-row>
</template>

<script>
import SidebarCheckboxFilter from '@/components/SidebarCheckboxFilter';

export default {
  name: 'SidebarCheckboxesFilter',
  components: {
    SidebarCheckboxFilter,
  },
  props: {
    attributes: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
